import { HIGHLIGHT_TEXT, LINK_TEXT } from '@anm/constants/embed';

import { HIGHLIGHT_INDEX, PopoverTypeIndexes, TEXT_LINK_INDEX } from '.';

export const getDefaultTextValue = (
  activePopoverType: PopoverTypeIndexes,
  currentText?: string
) => {
  const isDefault = currentText === HIGHLIGHT_TEXT || currentText === LINK_TEXT;

  if (currentText?.length && !isDefault) return currentText;

  const isTextLink = activePopoverType === TEXT_LINK_INDEX;
  const isHighLight = activePopoverType === HIGHLIGHT_INDEX;

  return isHighLight ? HIGHLIGHT_TEXT : isTextLink ? LINK_TEXT : '';
};
